import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: any) => ({
  form: {
    width: '100%',
    padding: theme.spacing(2),
  },
  formGrid: {
    display: 'grid',
    gridTemplateColumns: 'minmax(280px, calc(50% - 8px))',
    rowGap: theme.spacing(4),
    alignItems: 'start',
    [theme.breakpoints.down('sm')]: { gridTemplateColumns: '1fr' },
  },
  fieldGroup: { minWidth: 0 },
  fieldLabel: {
    display: 'block',
    marginBottom: theme.spacing(0.75),
    color: theme.palette.text.primary,
    fontSize: '1rem',
    lineHeight: 1.5,
  },
  userSelect: {
    '& .impersonation-user-select__control': {
      minHeight: 42,
      borderRadius: 4,
      borderColor: '#c4c4c4',
      boxShadow: 'none',
      backgroundColor: '#fff',
    },
    '& .impersonation-user-select__control:hover': { borderColor: '#212121' },
    '& .impersonation-user-select__control--is-focused': {
      borderColor: `${theme.palette.primary.main} !important`,
      borderWidth: 2,
    },
    '& .impersonation-user-select__value-container': { paddingTop: 0, paddingBottom: 0 },
    '& .impersonation-user-select__placeholder': { color: '#757575' },
  },
  description: {
    display: 'block',
    width: '100%',
    minHeight: 112,
    boxSizing: 'border-box',
    padding: theme.spacing(1.5, 1.75),
    border: '1px solid #c4c4c4',
    borderRadius: 4,
    backgroundColor: '#fff',
    color: theme.palette.text.primary,
    font: 'inherit',
    lineHeight: 1.5,
    resize: 'vertical',
    '&:hover': { borderColor: '#212121' },
    '&:focus': {
      border: `2px solid ${theme.palette.primary.main}`,
      outline: 'none',
      padding: `calc(${theme.spacing(1.5)}px - 1px) calc(${theme.spacing(1.75)}px - 1px)`,
    },
    '&::placeholder': { color: '#757575', opacity: 0.7 },
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(4),
    '& .MuiButton-root': { minWidth: 88 },
    '& .MuiButton-root.Mui-disabled': {
      color: '#9b9b9b',
      backgroundColor: '#e3e3e3',
      boxShadow: 'none',
    },
  },
}));
